/**
 * 8
 * 可复用的关键指标条，用于展示简要核心数据。 Figma：81033:19200
 *
 * `SummaryMetric.metricValue` / `metricChange` are display strings from the
 * backend (e.g. "30.56%", "26.35x") — not raw prices. Do not pass them through
 * FormattedPrice / BigDecimal, which only accepts numeric strings.
 */

import { SummaryMetric } from "./type";
import { cn } from "utils";

export interface AssetKeyStatsStripProps {
  items: SummaryMetric[];
}

export const AssetKeyStatsStrip: React.FC<AssetKeyStatsStripProps> = ({
  items,
}) => {
  return (
    <div className="flex gap-2 rounded-2 bg-background_solid_secondary p-2 bg-background_white_overlay5">
      {items.map((item) => (
        <div
          key={item.metricKey ?? item.metricName}
          className="flex min-w-0 flex-1 flex-col gap-1"
        >
          <span className="body_s text-content_tertiary">
            {item.metricName}
          </span>
          <div className="flex flex-col ">
            <span className="title_l text-content_primary">
              {item.metricValue}
            </span>
            <span
              className={cn("body_medium_s", {
                "text-content_accent1_primary":
                  item.metricChange.startsWith("+"),
                "text-content_accent2_primary":
                  item.metricChange.startsWith("-"),
              })}
            >
              {item.metricChange}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};
